import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';

export default {
    methods: {
        //获取列表
        getList() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                pageIndex: this.pageIndex,
                pageSize: this.pageSize
            };
            let $href = "api/NetWorkCheck/GetNetWorkCheckByPage"

            //过滤没有查询的值传入服务器
            for (let item in this.query) {
                let value = this.query[item];
                if (value !== "") {
                    // 去除空格trimAllSpace(str, is_global)  true 为去除所有空格
                    if (typeof value == 'string') {
                        value = util.trimAllSpace(value);
                    }
                    this.query[item] = value
                    params[item] = value;
                    if (item == "StockOutStartTime" || item == "StockOutEndTime" || item == 'FollowStartTime' || item == 'FollowEndTime') {
                        params[item] = util.time2str(value);
                    }
                }
            }
            if (this.$route.path == '/Network/networkDevice') {
                // 设备
                params.CheckStatus = 1
            } else if (this.$route.path == '/Network/networkCheck') {
                // 网络检测
                params.CheckStatus = 2
            } else {
                // 全部
                $href = 'api/NetWorkCheck/AllNetWorkCheckByPage'
            }
            this.loading = true;
            this.lists = []
            this.GetNetWorkCheckTotal()
            $http.get($href, params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.lists = Data;
                    this.totalSize = Cnt;
                    this.GetOptionByModId(params.CheckStatus)
                });
            });
        },
        // 汇总api/NetWorkCheck/GetNetWorkCheckTotal  Entrance  全部 0  非全部 -1
        GetNetWorkCheckTotal() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            //过滤没有查询的值传入服务器
            for (let item in this.query) {
                let value = this.query[item];
                if (value !== "") {
                    // 去除空格trimAllSpace(str, is_global)  true 为去除所有空格
                    if (typeof value == 'string') {
                        value = util.trimAllSpace(value);
                    }
                    this.query[item] = value
                    params[item] = value;
                    if (item == "StockOutStartTime" || item == "StockOutEndTime" || item == 'FollowStartTime' || item == 'FollowEndTime') {
                        params[item] = util.time2str(value);
                    }
                }
            }
            if (this.isAllData) {
                // 全部0
                params.Entrance = 0
            } else {
                params.Entrance = -1
            }
            $http.get("api/NetWorkCheck/GetNetWorkCheckTotal", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    this.totalData = Data
                });
            });
        },
        //获取跟进人列表
        GetFollowEmployeeList(Id) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                Id: Id
            };
            $http.get("api/NetWorkCheck/GetFollowEmployeeList", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    this.dropDowns = Data
                });
            });
        },
        //GET /api/NetWorkCheck/ModifyFollowEmployee
        ModifyFollowEmployee(Id, NextEmployeeId, FollowId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                Id: Id,
                NextEmployeeId: NextEmployeeId,
                FollowId: FollowId
            };
            this.loading = true;
            $http.get("api/NetWorkCheck/ModifyFollowEmployee", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '修改成功！',
                        type: 'success'
                    });
                    this.getList()
                });
            });
        },
        // 获取园所列表api/Common/GetSchoolList
        GetSchoolList() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                pageSize: 100000
            };
            $http.get("api/Common/GetSchoolList", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    this.schoolList = Data
                });
            });
        },
        // 获取班级列表GET /api/Class/ZqwPlatform_GetClassList
        GetClassList(SchoolId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                SchoolId: SchoolId
            };
            $http.get("api/Class/ZqwPlatform_GetClassList", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    this.classList = Data
                });
            });
        },
        // 获取检测进度下拉列表GET /api/Option/GetOptionByModId
        GetOptionByModId(ModuleId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                ModuleId: ModuleId
            };
            this.loading = true;
            this.FollowTypes = []
            $http.get("api/Option/GetOptionByModId", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.FollowTypes = Data
                });
            });
        },
        // 完成设备安装下推网络检测POST /api/NetWorkCheck/CompleteCheck
        CompleteCheck(data) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            this.loading = true;
            params = Object.assign({}, params, data);
            $http.post('api/NetWorkCheck/CompleteCheck', params).then(res => {
                this.loading = false
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '下推成功！',
                        type: 'success'
                    });

                });
            });
            this.getList()
        },
        // 回退POST /api/NetWorkCheck/ReturnCheck
        ReturnCheck(data) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            this.loading = true;
            params = Object.assign({}, params, data);
            $http.post('api/NetWorkCheck/ReturnCheck', params).then(res => {
                this.loading = false
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '回退成功！',
                        type: 'success'
                    });
                    this.getList()
                });
            });

        },
    }
}


// WEBPACK FOOTER //
// ./src/pages/Network/networkCheck/services.js